import { Link } from "react-router-dom";
import "../Auth/AuthCss/Login.css";
import { useLoginHook } from "./hooks/useLoginHook";

const Login = () => {
  //   const {} = useLoginContext();
  const { register, handleSubmit, errors, loginSubmit } = useLoginHook();
  return (
    <div className="login_wepper">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 p-0">
            <div className="login_inner_wepper">
              <h2>Login</h2>
              <form onSubmit={handleSubmit(loginSubmit)}>
                <div className="row from_wepper">
                  <div className="col-lg-12">
                    <div className="form-group ">
                      <label htmlFor="fname">Email</label>
                      <div className="add_user_input">
                        <input
                          type="text"
                          name="fname"
                          className="form-control"
                          placeholder="Enter your email"
                          fdprocessedid="bftiel"
                          {...register("email", { required: true })}
                          aria-invalid={errors.email ? "true" : "false"}
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M8 8.47533L0.01 2H15.99L8 8.47533ZM8 10.1913L0 3.708V14H16V3.708L8 10.1913Z"
                            fill="#6F757E"
                          />
                        </svg>
                      </div>
                      {errors.email?.type === "required" && (
                        <p role="alert" className="alert">
                          Email Id is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group ">
                      <label htmlFor="fname">Password</label>
                      <div className="add_user_input">
                        <input
                          type="password"
                          name="fname"
                          className="form-control"
                          placeholder="********"
                          fdprocessedid="bftiel"
                          {...register("password", { required: true })}
                          autoComplete="on"
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_847_322)">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M8.536 6C9.228 4.80467 10.5207 4 12 4C14.2073 4 16 5.79267 16 8C16 10.2073 14.2073 12 12 12C10.5207 12 9.228 11.1953 8.536 10H6L4.996 8.998L4 10L3.01333 8.998L2 10L0 7.97867L1.68667 6H8.536V6ZM13.6667 7C14.2187 7 14.6667 7.448 14.6667 8C14.6667 8.552 14.2187 9 13.6667 9C13.1147 9 12.6667 8.552 12.6667 8C12.6667 7.448 13.1147 7 13.6667 7Z"
                              fill="#6F757E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_847_322">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      {errors.password && (
                        <p role="alert" className="alert">
                          Password is required
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="forgot_password">
                    <Link /**to="/reset-password"**/>Forget password</Link>
                  </div>
                  <div className="col-lg-12 submit_btn">
                    <input type="submit" value="Log in" />
                  </div>
                  {/* <div className="accout_setp">
                    <p>
                      Don’t have an account ? <Link to="/signup">Sign up</Link>
                    </p>
                  </div> */}
                </div>
              </form>
            </div>
          </div>

          <div className="col-lg-6 p-0">
            <div className="login_img_data">
              <img src="/images/right-login.png" alt="login_image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
